import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Box, Breadcrumbs as MuiBreadcrumbs, Link as MuiLink, Typography } from '@mui/material';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';

const routeLabels = {
  dashboard: 'Dashboard',
  bookings: 'Bookings',
  packages: 'Packages',
  users: 'Users',
  deals: 'Deals',
  promotions: 'Promotions',
  categories: 'Categories',
  settings: 'Settings'
};

function Breadcrumbs() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);

  // Remove the first empty string and any admin prefix
  const filteredPathnames = pathnames.filter(path => path && path !== 'admin');

  if (filteredPathnames.length === 0 || (filteredPathnames.length === 1 && filteredPathnames[0] === 'dashboard')) {
    return (
      <Box sx={{ mb: 2 }}>
        <MuiBreadcrumbs separator={<NavigateNextIcon fontSize="small" />}>
          <Typography color="text.primary" variant="body2">
            Dashboard
          </Typography>
        </MuiBreadcrumbs>
      </Box>
    );
  }

  return (
    <Box sx={{ mb: 2 }}>
      <MuiBreadcrumbs separator={<NavigateNextIcon fontSize="small" />}>
        <MuiLink
          component={Link}
          to="/dashboard"
          color="inherit"
          variant="body2"
          sx={{ textDecoration: 'none' }}
        >
          Dashboard
        </MuiLink>
        
        {filteredPathnames.map((pathname, index) => {
          const routeTo = `/${filteredPathnames.slice(0, index + 1).join('/')}`;
          const isLast = index === filteredPathnames.length - 1;
          const label = routeLabels[pathname] || pathname.charAt(0).toUpperCase() + pathname.slice(1);

          return isLast ? (
            <Typography key={pathname} color="text.primary" variant="body2">
              {label}
            </Typography>
          ) : (
            <MuiLink
              key={pathname}
              component={Link}
              to={routeTo}
              color="inherit"
              variant="body2"
              sx={{ textDecoration: 'none' }}
            >
              {label}
            </MuiLink>
          );
        })}
      </MuiBreadcrumbs>
    </Box>
  );
}

export default Breadcrumbs;